import ConsultationCard from "./ConsultationCard";

interface Consultation {
  id: string | number;
  clientName: string;
  consultationType: string;
  time: string;
  services: { name: string; category?: string; color?: string }[];
  email?: string;
  mobile?: string;
  landline?: string;

  customerId: number;
  formId: number;
}

interface ConsultationSectionProps {
  title: string;
  consultations: Consultation[];
  onConsultationClick: (id: string | number) => void;
}

const ConsultationSection = ({
  title,
  consultations,
  onConsultationClick,
}: ConsultationSectionProps) => {
  return (
    <section className="mb-0">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-xl font-semibold text-[#402B69]">{title}</h3>
      </div>

      <div className="space-y-4">
        {consultations.length > 0 ? (
          consultations.map((c) => (
            <ConsultationCard
              key={c.id}
              clientName={c.clientName}
              consultationType={c.consultationType}
              time={c.time}
              services={c.services}
              email={c.email}
              mobile={c.mobile}
              landline={c.landline}
              customerId={c.customerId}
              formId={c.formId}
              onClick={() => onConsultationClick(c.id)}
            />
          ))
        ) : (
          <p className="text-gray-400 italic text-center py-4">
            No consultations available
          </p>
        )}
      </div>
    </section>
  );
};

export default ConsultationSection;
